import {useState} from 'react';
import {Headline2, Body1} from '@ui/atoms/typography';
import {NotificationList} from './notification-list';
import {useNotificationInbox} from './use-notification-inbox';

export const NotificationPage = () => {
  const inbox = useNotificationInbox();
  const [filter, setFilter] = useState<'all' | 'unread'>('all');
  const visibleNotifications =
    filter === 'unread'
      ? inbox.notifications.filter(({unread}) => unread)
      : inbox.notifications;

  return (
    <main className="mx-auto flex w-full max-w-[900px] flex-col gap-6 pb-12">
      <div className="flex flex-col gap-2">
        <Headline2>Notifications</Headline2>
        <Body1 kind="textBody">
          Keep up with check-ins, comments, mentions, action items, and
          workspace updates.
        </Body1>
      </div>

      <section className="overflow-hidden rounded-[10px] border border-borderLight bg-white">
        <header className="flex flex-col gap-3 border-b border-borderLight p-4 sm:flex-row sm:items-center sm:justify-between sm:p-6">
          <div
            className="flex gap-2"
            role="tablist"
            aria-label="Notification filter">
            {(['all', 'unread'] as const).map((option) => (
              <button
                key={option}
                type="button"
                role="tab"
                aria-selected={filter === option}
                onClick={() => setFilter(option)}
                className={`rounded-lg px-4 py-2 text-sm font-medium ${
                  filter === option
                    ? 'bg-purple300 text-alwaysWhite'
                    : 'border border-borderDark text-textBody'
                }`}>
                {option === 'all' ? 'All' : `Unread (${inbox.unreadCount})`}
              </button>
            ))}
          </div>
          <button
            type="button"
            disabled={!inbox.unreadCount}
            onClick={inbox.markAllRead}
            className="w-fit text-sm font-medium text-purple300 disabled:cursor-not-allowed disabled:text-textMuted">
            Mark all as read
          </button>
        </header>
        <NotificationList
          notifications={visibleNotifications}
          isLoading={inbox.isLoading}
          isError={inbox.isError}
          onRetry={() => inbox.refetch()}
          onMarkRead={inbox.markRead}
          onMarkUnread={inbox.markUnread}
          onDismiss={inbox.dismiss}
        />
      </section>
    </main>
  );
};
